<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '客户'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="30%"
    top="20vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="100px" :rules="rules">
      <el-form-item label="客户编号" prop="ClientNumber">
        <el-input
          v-model.trim="item.ClientNumber"
          placeholder="请输入客户编号"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="ClientName">
        <el-input
          v-model.trim="item.ClientName"
          placeholder="请输入客户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属区域" prop="Area">
        <el-cascader
          style="width: 100%"
          v-model="item.Area"
          :options="areaOptions"
          :props="areaProps"
          clearable
        ></el-cascader>
      </el-form-item>
      <el-form-item label="业务组分类" prop="BusinessGroups">
          <el-select
            v-model="item.BusinessGroups"
            :multiple-limit="6"
            multiple
            filterable
            default-first-option
            placeholder="请选择业务组分类"
            style="width: 100%"
          >
            <el-option
              v-for="code in businessGroupList"
              :key="code.Type"
              :label="code.Name"
              :value="code.Type"
            ></el-option>
          </el-select>
        </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    businessGroupList:Array,
  },
  data() {
    return {
      areaProps: {
        value: "CodeID",
        label: "Name",
        children: "Children",
        checkStrictly: true,
      },
      areaOptions: [],
      item: {},
      rules: {
        ClientNumber: [
          { required: true, message: "客户编号不能为空", trigger: "blur" },
        ],
        ClientName: [
          { required: true, message: "客户名称不能为空", trigger: "blur" },
        ],
        Area: [
          {
            required: true,
            message: "所属区域不能为空",
            trigger: ["blur", "change"],
          },
        ], 
        BusinessGroups: [{ required: true, message: "业务组分类不能为空", trigger: "blur" }],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.choseArea();
      this.item = _.clone(this.value);
      this.item.Area = [];
      if (this.item.Province) this.item.Area[0] = this.item.ProvinceCodeID;
      if (this.item.City) this.item.Area[1] = this.item.CityCodeID;
      if (this.item.County) this.item.Area[2] = this.item.CountyCodeID;
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        if (this.item.Area[0]) this.item.ProvinceCodeID = this.item.Area[0];
        else this.item.ProvinceCodeID = "";
        if (this.item.Area[1]) this.item.CityCodeID = this.item.Area[1];
        else this.item.CityCodeID = "";
        if (this.item.Area[2]) this.item.CountyCodeID = this.item.Area[2];
        else this.item.CountyCodeID = "";
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID ? `client/${itemData.ID}` : "client",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
    choseArea() {
      this.$axios
        .get("area")
        .then((response) => {
          this.areaOptions = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
  },
};
</script>
